<template>
  <strip-row>
    <template v-slot:number>
      <text-input v-model="strip.number" :disabled="upload" />
    </template>
    <template v-slot:name>
      <text-input v-model="strip.name" :disabled="upload" />
    </template>
    <template v-slot:publish>
      <select-input :options="publishOptions" v-model="strip.free" :disabled="upload" />
    </template>
    <template v-slot:date>
      <text-input type="date" v-model="strip.publishDate" :disabled="upload" />
    </template>
    <template v-slot:upload>
      <div style="opacity: 0.5">
        <span v-if="uploaded">
          Saved
        </span>
        <span v-else-if="uploadProgress === 100">
          Processing
        </span>
        <span v-else-if="failed">
          Failed
        </span>
        <span v-else>
          {{ uploadProgress }}%
        </span>
      </div>
    </template>
  </strip-row>
</template>

<script>
import parseFilename from '@/utilities/parseFilename';
import { CLOUD_NAME, COMIC_PRESET } from '@/utilities/cloudinaryKeys';
import cloudinaryUpload from '@/utilities/cloudinaryUpload';
import publishOptions from '@/utilities/publishOptions';
import TextInput from '@/components/TextInput.vue';
import SelectInput from '@/components/SelectInput.vue';
import StripRow from './StripRow.vue';

export default {
  name: 'UploadStrip',
  props: {
    index: [String, Number],
    file: File,
    free: Boolean,
    publishDate: String,
    upload: Boolean,
  },
  components: {
    StripRow,
    TextInput,
    SelectInput,
  },
  data() {
    return {
      strip: {
        ...parseFilename(this.file.name),
        free: this.free,
        publishDate: this.publishDate,
        url: null,
      },
      publishOptions,
      uploadProgress: 0,
      uploaded: false,
      failed: false,
    };
  },
  watch: {
    free(value) {
      if (value !== this.strip.free) {
        this.strip.free = value;
      }
    },
    publishDate(value) {
      if (value !== this.strip.publishDate) {
        this.strip.publishDate = value;
      }
    },
    upload(value) {
      if (value) {
        this.startUpload();
      }
    },
  },
  methods: {
    startUpload() {
      if (this.uploaded) return;
      const vm = this;
      vm.failed = false;
      cloudinaryUpload({
        cloudName: CLOUD_NAME,
        preset: COMIC_PRESET,
        file: this.file,
        onProgress({ progress }) {
          vm.uploadProgress = progress;
        },
      }).then((response) => {
        vm.uploaded = true;
        const transformations = response.eager.map(upload => upload.secure_url);
        vm.$emit('uploaded', {
          ...this.strip,
          publishDate: new Date(this.strip.publishDate),
          urlThumb: transformations[0],
          url: transformations[1],
          urlMobile: transformations[2],
        });
      }).catch(() => {
        vm.failed = true;
        vm.$emit('failed', this.index);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.stripfile {
  display: flex;
  align-items: center;
  > div {
    margin-right: 20px;
    flex: 1;
    &:last-child {
      margin-right: 0;
      display: flex;
      justify-content: flex-end;
      width: 150px;
      flex: none;
    }
  }
}
</style>
